import {
  DEFLY_WALLET_MODAL_BODY_HEADER_CLOSE_BUTTON_STYLES,
  DEFLY_WALLET_MODAL_BODY_HEADER_STYLES,
  DEFLY_WALLET_MODAL_BODY_STYLES,
  DEFLY_WALLET_MODAL_STYLES
} from "./DeflyWallet.constants";

/**
 * This function is used to setup a MutationObserver to observe the DeflyConnect modal.
 * The DeflyWallet modal is a shadow DOM element, so we need to use MutationObserver to observe
 * the modal's shadow DOM to detect if the modal is opened.
 */
function setupDeflyConnectObserver() {
  const deflyConnectObserver = new MutationObserver(() => {
    const modalRoot = document.getElementById("defly-wallet-connect-modal-wrapper");
    const modalShadowRoot = modalRoot?.getElementsByTagName("defly-wallet-connect-modal");
    const deflyWalletModal = modalShadowRoot?.[0]?.shadowRoot?.querySelector(
      ".defly-wallet-modal"
    ) as HTMLDivElement | undefined;

    if (deflyWalletModal) {
      const deflyWalletModalBody = deflyWalletModal?.querySelector(
        ".defly-wallet-modal__body"
      ) as HTMLDivElement | undefined;

      deflyWalletModal.classList.replace(
        "defly-wallet-modal--desktop",
        "defly-wallet-modal--mobile"
      );

      Object.assign(deflyWalletModal.style, DEFLY_WALLET_MODAL_STYLES);

      if (deflyWalletModalBody) {
        const deflyWalletModalDesktopMode = deflyWalletModalBody.getElementsByTagName(
          "defly-wallet-modal-desktop-mode"
        )?.[0];
        const deflyWalletConnectModalDesktopMode =
          deflyWalletModalDesktopMode?.shadowRoot?.querySelector(
            ".defly-wallet-connect-modal-desktop-mode"
          ) as HTMLDivElement | undefined;

        if (deflyWalletConnectModalDesktopMode) {
          deflyWalletConnectModalDesktopMode.style.gridTemplateColumns = "unset";
        }

        Object.assign(deflyWalletModalBody.style, DEFLY_WALLET_MODAL_BODY_STYLES);

        overrideDeflyWalletModalBodyHeaderStyles(deflyWalletModalBody);
      }
    }
  });

  deflyConnectObserver.disconnect();

  deflyConnectObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function overrideDeflyWalletModalBodyHeaderStyles(deflyWalletModalBody: HTMLDivElement) {
  const deflyWalletModalBodyHeaderShadowRoot = deflyWalletModalBody.getElementsByTagName(
    "defly-wallet-modal-header"
  )?.[0];
  const deflyWalletModalBodyHeader =
    deflyWalletModalBodyHeaderShadowRoot?.shadowRoot?.querySelector(
      ".defly-wallet-modal-header"
    ) as HTMLDivElement | undefined;

  if (deflyWalletModalBodyHeader) {
    const deflyWalletModalHeaderBrand = deflyWalletModalBodyHeader.getElementsByClassName(
      "defly-wallet-modal-header__brand"
    )?.[0] as HTMLDivElement | undefined;
    const deflyWalletModalHeaderCloseButton =
      deflyWalletModalBodyHeader.getElementsByClassName(
        "defly-wallet-modal-header__close-button"
      )?.[0] as HTMLButtonElement | undefined;

    Object.assign(
      deflyWalletModalBodyHeader.style,
      DEFLY_WALLET_MODAL_BODY_HEADER_STYLES
    );

    if (deflyWalletModalHeaderBrand) {
      deflyWalletModalHeaderBrand.style.display = "none";
    }

    if (deflyWalletModalHeaderCloseButton) {
      Object.assign(
        deflyWalletModalHeaderCloseButton.style,
        DEFLY_WALLET_MODAL_BODY_HEADER_CLOSE_BUTTON_STYLES
      );
    }
  }
}

export {setupDeflyConnectObserver};
